import axios from "./base/v1";

export default {
  /*
   * Создание пустого заказа с записью если услуга пропущена
   *
   * Параметры:
   * {
   *     reception_id: идентификатор записи,
   *     product_id: услуга
   * }
   *
   * Ответ:
   * [
   * ]
   */
  skip(data) {
    return axios.post("reception/order/skip", data);
  },
  /*
   * Создание заказа с записью
   *
   * Параметры:
   * {
   *     reception_id: идентификатор записи,
   *     product_id: услуга,
   *     data: массив данных для заказа
   * }
   *
   * Ответ:
   * [
   *  {
   *      "id": идентификатор цели,
   *      "name": название
   *  }
   * ]
   */
  order(data = {}) {
    return axios.post("reception/order", data);
  },
  /*
   * Регистрация оплаты
   *
   * Ответ:
   * [
   *     redirect: url для перекидывания на оплату
   * ]
   */
  register(order_id) {
    return axios.get(`reception/order/register/${order_id}?reception=Y`);
  }
};
